import { Button } from '@/components/ui/button';
import { openAuthPopup } from '@/lib/onshape-auth';

/**
 * Login button component that opens OAuth pop-up
 */
export function LoginButton() {
  const handleLogin = () => {
    try {
      const popup = openAuthPopup();

      if (!popup) {
        alert('Please allow pop-ups for this site to sign in.');
        return;
      }

      // The pop-up will handle the OAuth flow
      // The callback page will send a message back via postMessage
    } catch (error) {
      console.error('Login error:', error);
      alert(`Authentication error: ${error.message}\n\nPlease check that VITE_ONSHAPE_CLIENT_ID is set in your .env file.`);
    }
  };

  return (
    <Button onClick={handleLogin} size="lg">
      Log in with Onshape
    </Button>
  );
}

